import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b06093a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "年度", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "年", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "組", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "in-charge-type-label" }, "担任タイプ:", -1))
const _hoisted_6 = { class: "message-area" }
const _hoisted_7 = {
  key: 0,
  class: "message-dot"
}
const _hoisted_8 = {
  key: 1,
  class: "message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditableItemNumber = _resolveComponent("EditableItemNumber")!
  const _component_EditableItemEnum = _resolveComponent("EditableItemEnum")!
  const _component_EditableItemText = _resolveComponent("EditableItemText")!
  const _component_RemoveButton = _resolveComponent("RemoveButton")!

  return (_openBlock(), _createElementBlock("li", {
    class: "teacher-classes-select-popup-item-container",
    style: _normalizeStyle(_ctx.styles)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_EditableItemNumber, {
        class: "input input--school-year",
        "aria-label": _ctx.schoolYearLabel,
        value: _ctx.schoolYear,
        "default-value": null,
        editable: true,
        "font-size": 13,
        "font-color": "black",
        "on-input": _ctx.onInputSchoolYearInternal
      }, null, 8, ["aria-label", "value", "on-input"]),
      _hoisted_2,
      _createVNode(_component_EditableItemEnum, {
        class: "input input--school-type",
        "aria-label": _ctx.schoolTypeLabel,
        value: _ctx.schoolType,
        options: _ctx.schoolTypeOptions,
        editable: true,
        "font-size": 13,
        "on-input": _ctx.onInputSchoolTypeInternal
      }, null, 8, ["aria-label", "value", "options", "on-input"]),
      _createVNode(_component_EditableItemEnum, {
        class: "input input--grade-number",
        "aria-label": _ctx.gradeNumberLabel,
        value: _ctx.gradeNumberSelectValue,
        options: _ctx.gradeNumberOptions,
        editable: true,
        "font-size": 13,
        "font-color": "black",
        "on-input": _ctx.onInputGradeNumberInternal
      }, null, 8, ["aria-label", "value", "options", "on-input"]),
      _hoisted_3,
      _createVNode(_component_EditableItemEnum, {
        class: "input input--class",
        "aria-label": _ctx.classNameLabel,
        value: _ctx.classIdSelectValue,
        options: _ctx.classOptions,
        editable: _ctx.classInputEnabled,
        "font-size": 13,
        "hide-box-on-disable": false,
        "on-input": _ctx.onInputClassInternal
      }, null, 8, ["aria-label", "value", "options", "editable", "on-input"]),
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_EditableItemText, {
        class: "input input--in-charge-type",
        "aria-label": _ctx.inChargeTypeLabel,
        value: _ctx.inChargeType,
        editable: true,
        "max-length": 1,
        "font-size": 13,
        "font-color": "black",
        "on-input": _ctx.onInputInChargeTypeInternal
      }, null, 8, ["aria-label", "value", "on-input"]),
      _createVNode(_component_RemoveButton, {
        class: "remove-button",
        "aria-label": "Delete",
        "on-click": _ctx.onRemove,
        "icon-size": 11
      }, null, 8, ["on-click"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.message != null)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "*"))
        : _createCommentVNode("", true),
      (_ctx.message != null)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.message), 1))
        : _createCommentVNode("", true)
    ])
  ], 4))
}